import accountsService from './accounts.service';
import ApiService from './ApiService';
import intervenerService from './interveners.service';
import operationsService from './operations.service';

/**
 * @override
 */
class DocumentsService extends ApiService {
    /**
     * Obtenemos un documento
     * @param {*} type Tipo de documento: Account/Intervener....
     * @param {*} uuid Identificador del padre al que pertenece el documento
     * @param {*} uuidDocument Identificador del documento
     * @return {Object} Response data
     */
    get(type, uuid, uuidDocument) {
        switch (type.toUpperCase()) {
            case 'ACCOUNT':
            case 'BANK_ACCOUNTS':
                return accountsService.getDocument(uuid, uuidDocument);
            case 'INTERVENER':
            case 'INTERVENERS':
                return intervenerService.getDocument(uuid, uuidDocument);
            case 'OPERATION':
                return operationsService.getDocument(uuid, uuidDocument);
            default:
                break;
        }
        return Promise.reject(`Unkown document entity type "${type}".`);
    }

    /**
     * Subimos un documento
     * @param {Object} payload Info del upload
     * @return {Object} Response data
     */
    upload(payload) {
        switch (payload.section.toUpperCase()) {
            case 'ACCOUNT':
            case 'BANK_ACCOUNTS':
                return accountsService.upload(payload);
            case 'INTERVENER':
            case 'INTERVENERS':
                return intervenerService.upload(payload);
            case 'OPERATION':
                return operationsService.upload(payload);
            default:
                break;
        }
        return Promise.reject(`Unkown section "${payload.section}".`);
    }

    /**
     * Actualizamos un documento
     * @param {*} type Tipo de documento: Account/Intervener....
     * @param {*} payload Información para actualizar
     * @return {Object} Response data
     */
    update(type, payload) {
        switch (type.toUpperCase()) {
            case 'ACCOUNT':
                return accountsService.updateDocument(
                    payload.uuid,
                    payload.uuidDocuemnt,
                    payload.data
                );
            case 'INTERVENER':
            case 'INTERVENERS':
                return intervenerService.updateDocument(
                    payload.uuid,
                    payload.uuidDocuemnt,
                    payload.data
                );
            case 'OPERATION':
                return operationsService.updateDocument(
                    payload.uuid,
                    payload.uuidDocuemnt,
                    payload.data
                );
            default:
                break;
        }
        return true;
    }
}

const documentsService = new DocumentsService();

export default documentsService;
